import { render, staticRenderFns } from "./ModalConfirmTitle.vue?vue&type=template&id=0c5b566b&"
import script from "./ModalConfirmTitle.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports